import { create } from "zustand";
import * as pc from "playcanvas";
import {
  SightlineVerifierResponse
} from "@/types/sightlineVerifier";

type AutoPlayData = {
  time: number;
  delay: number;
};

interface ModelViewerState {
  resetPositionRotationEvent: number;
  triggerResetPositionRotationEvent: () => void;

  resetOnlyRotationEvent: number;
  triggerResetOnlyRotationEvent: () => void;

  positionJoystickData: number[];
  setPositionJoystickData: (value: number[]) => void;
  rotationJoystickData: number[];
  setRotationJoystickData: (value: number[]) => void;

  progress: number;
  setProgress: (value: number) => void;

  isModelLoaded: boolean;
  setIsModelLoaded: (value: boolean) => void;

  errorMessage: string;
  setErrorMessage: (value: string) => void;

  startAutoPlayData: AutoPlayData;
  startAutoPlayDelay: (delay: number) => void;

  stopAutoPlayData: number;
  stopAutoPlay: () => void;

  interruptAutoPlayEvent: number;
  interruptAutoPlay: () => void;

  cameraMode: number;
  switchModelViewerCameraMode: () => void;

  cameraPosition: pc.Vec3;
  setCameraPosition: (data: pc.Vec3) => void;

  cameraLookingPosition: pc.Vec3;
  setCameraLookingPosition: (data: pc.Vec3) => void;

  cameraAngle: number;
  setCameraAngle: (value: number) => void;

  sightlineVerifierData?: SightlineVerifierResponse;
  setSightlineVerifierData: (value: SightlineVerifierResponse) => void;

}

export const useModelViewerStore = create<ModelViewerState>()((set, get) => ({
  resetPositionRotationEvent: 0,
  triggerResetPositionRotationEvent: () => {
    set({ resetPositionRotationEvent: Date.now() });
  },

  resetOnlyRotationEvent: 0,
  triggerResetOnlyRotationEvent: () => {
    set({ resetOnlyRotationEvent: Date.now() });
  },

  positionJoystickData: [0, 0],
  setPositionJoystickData: (value: number[]) => {
    set({ positionJoystickData: value });
  },
  rotationJoystickData: [0, 0],
  setRotationJoystickData: (value: number[]) => {
    set({ rotationJoystickData: value });
  },

  progress: 0,
  setProgress: (value: number) => {
    set({ progress: value });
  },

  isModelLoaded: false,
  setIsModelLoaded: (value: boolean) => {
    set({ isModelLoaded: value });
  },

  errorMessage: "",
  setErrorMessage: (value: string) => {
    set({ errorMessage: value });
  },

  startAutoPlayData: { time: -1, delay: -1 },
  startAutoPlayDelay: (delay: number) => {
    set({ startAutoPlayData: { time: Date.now(), delay: delay }});
  },

  stopAutoPlayData: -1,
  stopAutoPlay: () => {
    set({ stopAutoPlayData: Date.now() });
  },

  interruptAutoPlayEvent: -1,
  interruptAutoPlay: () => {
    set({ interruptAutoPlayEvent: Date.now() });
  },

  cameraMode: 0,
  switchModelViewerCameraMode: () => {
    set((state) => ({ cameraMode: state.cameraMode === 0 ? 1 : 0 }));
  },

  cameraPosition: new pc.Vec3(0, 0, 0),
  setCameraPosition: (data: pc.Vec3) => {
    set({ cameraPosition: data });
  },

  cameraLookingPosition: new pc.Vec3(0, 0, 0),
  setCameraLookingPosition: (data: pc.Vec3) => {
    set({ cameraPosition: data });
  },

  cameraAngle: 0,
  setCameraAngle: (value: number) => {
    set({ cameraAngle: value });
  },

  setSightlineVerifierData: (value: SightlineVerifierResponse) => {
    set({ sightlineVerifierData: value });
  },
}));
